import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type RrcCompanyRole = DatabaseCode;

const generator: RrcCompanyRole = {
  code: "GENERATOR",
  displayValue: {
    id: "common.entity.rrccompanyrole.generator",
    defaultMessage: "Generator",
  },
};

const transporter: RrcCompanyRole = {
  code: "TRANSPORTER",
  displayValue: {
    id: "common.entity.rrccompanyrole.transporter",
    defaultMessage: "Transporter",
  },
};

const receiver: RrcCompanyRole = {
  code: "RECEIVER",
  displayValue: {
    id: "common.entity.rrccompanyrole.receiver",
    defaultMessage: "Receiver",
  },
};

export const rrcCompanyRole = {
  generator,
  transporter,
  receiver,
};

export const rrcCompanyRoles: RrcCompanyRole[] = Object.values(rrcCompanyRole);

export const toRrcCompanyRole = (code: string): RrcCompanyRole =>
  toDatabaseCode(code, rrcCompanyRoles);

export const toRrcCompanyRoleSafely = (
  code: string | undefined,
  defaultValue: RrcCompanyRole | undefined = undefined
): RrcCompanyRole | undefined => toDatabaseCodeSafely(code, rrcCompanyRoles, defaultValue);
